import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { CiEdit } from 'react-icons/ci';


interface BusinessStructure {
  id:number; 
giver :number; 
receiver: number;
workBy:string;
referenceId:string;
status : string;
date:string;
amount:number;
Testimonial :string;
}


interface UserStructure {
  id: number;
  name: string;
}

const Business = () => {
  const api = process.env.REACT_APP_API_URL as string;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  
   const [reportData, setReportData] = useState<BusinessStructure[]>([]);
     const [userData, setUserData] = useState<UserStructure[]>([]);
   useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${api}/auth/business`
        );

        // console.log("business data", response.data.data);
        setReportData(response.data.data);
        // console.log("report data in a array", reportData.length);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<UserStructure[]>(
          `${api}/auth/allusersinfo`
        );

        //console.log("news data", response.data);
        setUserData(response.data);
        //console.log("user data in a array", newData);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);


  const openModal = (postId: number) => {
    setSelectedUserId(postId);
    setIsModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeModal = () => {
    setSelectedUserId(null);
    setIsModalOpen(false);
  };
  return (
    <div><div className="px-2 py-3 overflow-y-auto">
           <table className="table-auto w-full border-collapse border bg-white border-gray-300">
      <thead className="bg-darkblue text-white">
        <tr>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Date</th>
          
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Giver</th>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Receiver</th>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Self / Reference</th>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Status</th>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Amount</th>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left">Testimonial </th>
          <th className="border-y border-y-gray-300 px-4 py-2 text-left"></th>
        </tr>
      </thead>
      <tbody>
        {reportData.length > 0 ? (
          reportData.map((item) => (
            <tr  className="border border-gray-300">
              <td className="border-y border-y-gray-300 px-4 py-2">
                {item.date.split('T')[0]}
              </td>
              
              <td className="border-y border-y-gray-300 px-4 py-2">
  {userData.find((items) => items.id === item.giver)?.name || "N/A"}
</td>

<td className="border-y border-y-gray-300 px-4 py-2">
  {userData.find((items) => items.id === item.receiver)?.name || "N/A"}
</td>
<td className="border-y border-y-gray-300 px-4 py-2">
{item.workBy}
              </td>
              {/* <td className="border-y border-y-gray-300 px-4 py-2"></td> */}
                 <td className={`border-y border-y-gray-300 px-4 py-2 ${item.status=='Approve'?'text-green-600':item.status=='Pending'?'text-textyellow':'text-red-600'}`}>{item.status}</td>
                 <td className="border-y border-y-gray-300 px-4 py-2">
                ₹{new Intl.NumberFormat('en-IN').format(item.amount)}
              </td>
                 <td className="border-y border-y-gray-300 px-4 py-2">
                {item.Testimonial}
              </td>
             
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={7} className="text-center py-4">
              Loading...
            </td>
          </tr>
        )}
      </tbody>
    </table>

    
    </div></div>
  )
}




export default Business